<footer class="bg-white border-t border-gray-200 mt-auto z-10 w-full">
  <div class="py-12 flex justify-center items-center">
    <img
      src="assets/img/Polizia-di-Stato---logo-2025v2.png"
      alt="Polizia di Stato"
      class="h-8 w-auto"
    />
  </div>
  <div class="grid grid-cols-4 px-10 py-14 border-b border-t border-slate-200">
    <div>
      <h3 class="text-black font-semi-bold uppercase text-xs">contatti</h3>
      <ul class="pt-7 leading-7 font-regular text-black underline text-sm list-none">
        <li>
          <a
            href="https://questure.poliziadistato.it/it/servizio/dovesiamo"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Dove Siamo (apre in una nuova scheda)"
            >Dove Siamo</a
          >
        </li>
        <li>
          <a
            href="https://www.poliziadistato.it/scrivici/message"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Scrivici (apre in una nuova scheda)"
            >Scrivici</a
          >
        </li>
      </ul>
    </div>
    <div>
      <h3 class="text-black font-semi-bold uppercase text-xs">social network</h3>
      <ul class="pt-7 leading-7 font-regular text-black underline text-sm list-none">
        <li>
          <a
            href="https://www.facebook.com/poliziadistato.it?fref=ts"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook (apre in una nuova scheda)"
            >Facebook</a
          >
        </li>
        <li>
          <a
            href="https://www.instagram.com/poliziadistato/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram (apre in una nuova scheda)"
            >Instagram</a
          >
        </li>
        <li>
          <a
            href="https://x.com/poliziadistato"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X (apre in una nuova scheda)"
            >X</a
          >
        </li>
        <li>
          <a
            href="https://www.youtube.com/user/poliziadistato"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube (apre in una nuova scheda)"
            >YouTube</a
          >
        </li>
        <li>
          <a
            href="https://t.me/poliziadistato"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Telegram (apre in una nuova scheda)"
            >Telegram</a
          >
        </li>
      </ul>
    </div>
    <div>
      <h3 class="text-black font-semi-bold uppercase text-xs">link utili</h3>
      <ul class="pt-7 leading-7 font-regular text-black underline text-sm list-none">
<!--         <li>
          <a [routerLink]="faqRoute">FAQ</a>
        </li>
 -->        <li>
          <a
            href="https://poliziamoderna.poliziadistato.it/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Polizia Moderna (apre in una nuova scheda)"
            >Polizia Moderna</a
          >
        </li>
        <!--                 <li><a href="https://dv.poliziadistato.it/login?redirect_url=/" target="_blank" rel="noopener noreferrer" aria-label="Doppiavela (apre in una nuova scheda)">Doppiavela</a></li> -->
        <li>
          <a
            href="https://www.commissariatodips.it/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Commissariato di PS Online (apre in una nuova scheda)"
            >Commissariato di PS Online</a
          >
        </li>
        <!--                 <li><a href="https://www.poliziadistato.it/pds/ps/ufficiostampa/rassegna_stampa/pw_rassegna_stampa.htm" target="_blank" rel="noopener noreferrer" aria-label="Rassegna Stampa (apre in una nuova scheda)">Rassegna Stampa</a></li> -->
      </ul>
    </div>
    <div class="flex flex-col justify-between">
      <div>
        <h3 class="text-black font-semi-bold uppercase text-xs">assistenza al cittadino</h3>
        <ul class="font-regular text-black underline text-sm pt-7 list-none">
          <li>
            <a
              href="https://112.gov.it/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="1-1-2 Numero Unico Europeo (apre in una nuova scheda)"
              >1-1-2 Numero Unico Europeo</a
            >
          </li>
        </ul>
      </div>
      <app-icon iconName="internalMinistryLogo" aria-label="Ministero dell'Interno" />
    </div>
  </div>
  <div class="grid grid-cols-2 py-6 px-10 font-regular text-xs">
    <ul class="flex justify-start gap-8 underline list-none">
      <!--             <li>Dichiarazione di Accessibilità</li>
            <li>Note Legali</li>
            <li>Privacy e Cookie Policy</li> -->
    </ul>
    <div class="flex justify-end items-end px-5"></div>
  </div>
</footer>
